import { useLocale } from "@reco/shared/src/composables/useLocale";
import { EnvironmentConfig } from "@reco/shared/src/types/config";
import { getTrackingPageType } from "./pageType";

const DEBUG_KEY = "recommendationsDebug";

export function getHostByEnv(hostname: string) {
  const envs = [
    {
      host: "https://recommendations-dev.lidl-shop.com",
      env: "local",
      regex: "localhost",
    },
    {
      host: "https://recommendations-dev.lidl-shop.com",
      env: "dev",
      regex: "dev",
    },
    {
      host: "https://recommendations-test.lidl-shop.com",
      env: "test",
      regex: "test",
    },
    {
      host: "https://recommendations-qa.lidl-shop.com",
      env: "qa",
      regex: "qa",
    },
    {
      host: "https://recommendations.lidl-shop.com",
      env: "prod",
      regex: "www",
    },
  ];
  return envs.find((template) => hostname.startsWith(template.regex)) || envs[4];
}

export function getDebugConfig() {
  try {
    return JSON.parse(sessionStorage.getItem(DEBUG_KEY) || "{}");
  } catch {
    sessionStorage.removeItem(DEBUG_KEY);
    return {};
  }
}

export function getEnvironmentConfig(): EnvironmentConfig {
  const { pathname, hostname } = globalThis.location;
  const debugConfig = getDebugConfig();
  const { country, language } = useLocale();

  return {
    recoApiPost: debugConfig.recoApiPost,
    countryId: country.value,
    displayLimit: 8,
    languageId: language.value,
    pathname: pathname,
    pageType: getTrackingPageType(pathname),
    recoHost: getHostByEnv(hostname).host,
    env: getHostByEnv(hostname).env,
    requestLimit: 20,
  };
}
